import { IEntity } from './entity';

export enum LogisticActivityEnum {
  TRANSIT_TO_TASK_BY_ROAD = 1,
  TRANSIT_TO_TASK_PUBLIC_TRANSPORT = 2,
}

export interface ITaskLogistic extends IEntity {
  taskId: number;
  previousTaskId: number;
  isEstimate: boolean;
  activity: LogisticActivityEnum;
  distanceMiles: number;
  durationMinutes: number;
  costPounds: number;
}

export interface ITaskTransit {
  byRoadDistanceMiles?: number;
  byRoadDurationMinutes?: number;
  byRoadCostPounds?: number;

  byPublicTransportDistanceMiles?: number;
  byPublicTransportDurationMinutes?: number;
  byPublicTransportCostPounds?: number;
}
